import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { CategoriaArquivoRequest } from '../../requests/integracao-arquivos/categoria-arquivo.request';
import { ListaCategoriaArquivoResponse } from '../../responses/integracao-arquivos/lista-categoria-arquivo.response';
import { ReturnStruct } from '../../structs/return.struct';
import { CategoriaArquivoResponse } from '../../responses/integracao-arquivos/categoria-arquivo.response';
import { ListaTagArquivoResponse } from '../../responses/integracao-arquivos/lista-tag-arquivo.response';

@Injectable({
  providedIn: 'root',
})
export class CategoriaArquivoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public obterListaCategoriaArquivo(
    nome: string | null,
    paginaAtual: number
  ): Observable<ListaCategoriaArquivoResponse> {
    let params = new HttpParams();

    if (nome) {
      params = params.set('nome', nome);
    }

    return this.httpClient
      .get<ListaCategoriaArquivoResponse>(
        environment.urlApiIntegracaoArquivos + `categoriaarquivo/listacategoriaarquivo/${paginaAtual}`,
        {
          headers: this.addHeaderToken().headers,
          params: params,
        }
      )
      .pipe(catchError(this.handleError));
  }

  public lookup(): Observable<ListaCategoriaArquivoResponse> {
    return this.httpClient
      .get<ListaCategoriaArquivoResponse>(
        environment.urlApiIntegracaoArquivos + `categoriaarquivo/lookup`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public excluir(idCategoriaArquivo: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(
        environment.urlApiIntegracaoArquivos + `categoriaarquivo/idCategoriaArquivo/${idCategoriaArquivo}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public incluir(categoriaArquivoRequest: CategoriaArquivoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiIntegracaoArquivos + `categoriaarquivo/`,
        categoriaArquivoRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public pesquisaCategoriaPorId(idCategoriaArquivo?: number): Observable<CategoriaArquivoResponse> {
    return this.httpClient
      .get<CategoriaArquivoResponse>(
        environment.urlApiIntegracaoArquivos + `categoriaarquivo/idCategoriaArquivo/${idCategoriaArquivo}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public alterar(
    idCategoriaArquivo: number,
    categoriaArquivoRequest: CategoriaArquivoRequest
  ): Observable<CategoriaArquivoResponse> {
    return this.httpClient
      .put<CategoriaArquivoResponse>(
        environment.urlApiIntegracaoArquivos + `categoriaarquivo/idCategoriaArquivo/${idCategoriaArquivo}`,
        categoriaArquivoRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public obterListaTagArquivo(idCategoriaArquivo: number): Observable<ListaTagArquivoResponse> {
    return this.httpClient
      .get<ListaTagArquivoResponse>(
        environment.urlApiIntegracaoArquivos +
          `categoriaarquivo/listatagarquivo/idCategoriaArquivo/${idCategoriaArquivo}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public lookupListaTagArquivo(): Observable<ListaTagArquivoResponse> {
    return this.httpClient
      .get<ListaTagArquivoResponse>(
        environment.urlApiIntegracaoArquivos + `categoriaarquivo/listatagarquivo/lookup`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
